<script>
  import { onMount, createEventDispatcher } from "svelte";
  import Textfield from "@smui/textfield";
  import { MDCTextField } from "@material/textfield";

  let element;
  let textfield;
  let search;
  let autocomplete;
  let address = {};
  let locationBias;
  let value = "";

  const dispatch = createEventDispatcher();

  function geolocate() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        var geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        var circle = new google.maps.Circle({
          center: geolocation,
          radius: position.coords.accuracy
        });
        console.log("Setting bounds: ", circle.getBounds());
        autocomplete.setBounds(circle.getBounds());
      });
    }
  }

  function fillAddress() {
    const place = autocomplete.getPlace();
    console.log("Got place: ", place);
    if (place.address_components) {
      const address = {};
      place.address_components.forEach(e => {
        if (e.types.includes("street_number")) {
          address.address_line_1 = e.long_name;
        } else if (e.types.includes("route")) {
          address.address_line_1 =
            (address.address_line_1 || "") + " " + e.long_name;
        } else if (e.types.includes("neighborhood")) {
          address.address_line_2 = e.long_name;
        } else if (e.types.includes("postal_town")) {
          address.city = e.long_name;
        } else if (e.types.includes("postal_code")) {
          address.post_code = e.long_name;
        }
      });
      if (place.place_id) {
        address.google_place_id = place.place_id;
      }
      dispatch("complete", address);
      search.value = "";
    }
  }

  function initAutocomplete() {
    if (!autocomplete && window.google) {
      try {
        console.log("init autocomplete, search ", search);
        autocomplete = new google.maps.places.Autocomplete(search, {
          types: ["geocode", "establishment"]
        });
        autocomplete.setFields(["address_component", "place_id"]);
        autocomplete.addListener("place_changed", fillAddress);
        console.log("initAutocomplete completed");
      } catch (error) {
        console.log("initAutocomplete: ", error);
      }
    }
  }

  onMount(() => {
    textfield = new MDCTextField(element);
    initAutocomplete();
  });
</script>

<svelte:window on:maps-loaded={initAutocomplete} />

<div bind:this={element} class="mdc-text-field mdc-text-field--outlined">
  <input
    type="text"
    bind:this={search}
    id="address-search"
    on:focus={geolocate}
    class="mdc-text-field__input" />
  <div class="mdc-notched-outline">
    <div class="mdc-notched-outline__leading" />
    <div class="mdc-notched-outline__notch">
      <label for="address-search" class="mdc-floating-label">
        Search Address
      </label>
    </div>
    <div class="mdc-notched-outline__trailing" />
  </div>

</div>
